import constants from '~globals/constants';

const initialState = {
    allianceId: '',
    companyUrl: '',
    fbclid: '', // TODO never assigned a value
    filter: '',
    gclid: '', // TODO never assigned a value
    geoLocation: { countyName: '', zip: '' } as GeoLocation,
    multiCountyList: [] as GeoLocation[],
    hasAnyLeadPopupShown: false,
    hideDismissableStickyPermanently: false,
    hours: '',
    lastUpdated: '', // TODO never assigned a value
    leadId: '',
    leadToken: '',
    lightModeHeader: false,
    logo: '',
    mktCode: '', // TODO never assigned a value
    msclid: '', // TODO never assigned a value
    ntmActiveStep: '',
    ntmVisited: [] as string[],
    marketoFormId: '',
    preOepStateConfig: {} as LeadFormData,
    oepStateConfig: [] as BannerData[],
    oepStatePeriod: {} as PeriodData,
    partnerName: '',
    partnershipType: '',
    phone: { number: constants.DEFAULT_PHONE as string, isFinal: false },
    planType: '' as PlansType,
    planYear: new Date().getFullYear(),
    segmentType: '',
    suppressEmailCapturePopup: false,
    tcpaDisclaimer: '',
    throttle: '' as IThrottle,
    trackingParams: {} as Record<
        EhmTrackingParameters | OtherTrackingParameters | ClickIds,
        string
    >,
    trackingStatus: '',
    zipModalConfig: {
        customDestination: process.env.GATSBY_EHMP_URL,
        customHeading: '',
        customCta: '',
    },
};

export default initialState;
